// api.js
import axios from 'axios';
const { REACT_APP_API_ENDPOINT } = process.env;
const api = axios.create({
  baseURL: `${REACT_APP_API_ENDPOINT}`,
});


// Funzione per ottenere le campagne
export const getUfficioDepositoId = async (selectedGarage) => {
  try {
    const response = await api.get(`/api/managed/deposito?recapito=${selectedGarage}`);
    return response.data;
  } catch (error) {
    console.error('Errore nel recupero del deposito:', error);
    throw error;
  }
};




